function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * AAAA IDP Payment page
 * 
 */
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import AlreadyPaid from '../../components/already-paid/AlreadyPaid';
import ErrorApp from '../../components/error-app/ErrorApp';
import OrderExpirationModal from '../../components/order-expiration-modal/OrderExpirationModal';
import Progress from '../../components/progress/Progress';
import PaymentText from '../../components/payment-text/PaymentText';
import Footer from './footer/Footer';
import CountdownTimer from './countdown-timer/CountdownTimer';
import Loading from '../../components/loading/Loading';
import { transaction, validate } from '../../actions';
import { countErrors } from '../../functions/Functions';
import { trackInitiateCheckout } from '../../utils/metaPixel';
import './PaymentPage.scss';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export class PaymentPage extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "timeoutID", void 0);
    /**
     * check errors
     * @returns
     */
    _defineProperty(this, "checkErrors", () => {
      const errors = countErrors(this.props);
      const show = errors === 0 ? true : false;
      this.setState({
        errors,
        show
      });

      // Track InitiateCheckout when payment page is shown successfully
      if (show) {
        this.trackInitiateCheckout();
      }
    });
    /**
     * Track InitiateCheckout event via Meta Pixel (loaded via GTM)
     */
    _defineProperty(this, "trackInitiateCheckout", () => {
      const {
        application,
        postage
      } = this.props;
      const checkoutId = application?.id || application?.submission_token || '';
      const value = postage?.cost || 0;
      if (!checkoutId) {
        return;
      }
      trackInitiateCheckout({
        checkoutId,
        value,
        currency: 'AUD'
      });
    });
    /**
     * Timer to avoid memory leaks.
     * We delay showing the main payment components until we validate data
     */
    _defineProperty(this, "timer", () => {
      return setTimeout(this.checkErrors, 1000);
    });
    /**
     * Set expired page
     */
    _defineProperty(this, "setPageExpired", () => {
      this.setState({
        expired: true
      });
    });
    /**
     * Reload the page
     */
    _defineProperty(this, "reload", e => {
      if (e) {
        e.preventDefault();
      }
      window.location.reload();
    });
    const {
      jest,
      setTransaction
    } = props;

    // reset this in case of retried payment
    setTransaction({
      apiSuccess: false
    });
    this.state = {
      errors: 0,
      expired: false,
      show: false
    };

    // scroll to top
    if (!jest) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  }
  componentDidMount() {
    this.props.validate();
    this.timeoutID = this.timer();
  }
  componentWillUnmount() {
    clearTimeout(this.timeoutID);
  }
  render() {
    const {
      application,
      bugsnagClient,
      transaction
    } = this.props;
    const {
      errors,
      expired,
      show
    } = this.state;
    const {
      id,
      submission_token
    } = application;
    const {
      apiSuccess,
      success
    } = transaction;
    switch (true) {
      case (!id || !submission_token) && show:
        return /*#__PURE__*/_jsx(ErrorApp, {
          bugsnagClient: bugsnagClient
        });
      case errors > 0:
        return /*#__PURE__*/_jsx(Redirect, {
          to: "/details"
        });
      case apiSuccess && success:
        return /*#__PURE__*/_jsxs(Fragment, {
          children: [/*#__PURE__*/_jsx(Progress, {}), /*#__PURE__*/_jsx("section", {
            className: "form-container",
            children: /*#__PURE__*/_jsx("div", {
              className: "PaymentPage",
              children: /*#__PURE__*/_jsx(AlreadyPaid, {})
            })
          })]
        });
      case show:
        return /*#__PURE__*/_jsxs(Fragment, {
          children: [/*#__PURE__*/_jsx(OrderExpirationModal, {}), /*#__PURE__*/_jsx(Progress, {}), /*#__PURE__*/_jsxs("section", {
            className: "form-container",
            children: [/*#__PURE__*/_jsx(CountdownTimer, {
              expired: expired,
              setPageExpired: this.setPageExpired,
              reload: this.reload
            }), /*#__PURE__*/_jsxs("div", {
              className: "PaymentPage",
              children: [/*#__PURE__*/_jsx(PaymentText, {}), /*#__PURE__*/_jsx(Footer, {
                ...this.props
              }), expired ? /*#__PURE__*/_jsx("div", {
                className: "expired",
                onClick: this.reload,
                children: /*#__PURE__*/_jsx("div", {
                  className: "text",
                  children: "Click to reload the page to continue your transaction"
                })
              }) : null]
            })]
          })]
        });
      default:
        return /*#__PURE__*/_jsxs(Fragment, {
          children: [/*#__PURE__*/_jsx(Progress, {}), /*#__PURE__*/_jsx("section", {
            className: "form-container",
            children: /*#__PURE__*/_jsxs("div", {
              className: "PaymentPage",
              children: [/*#__PURE__*/_jsx(PaymentText, {}), /*#__PURE__*/_jsx(Loading, {})]
            })
          })]
        });
    }
  }
}
_defineProperty(PaymentPage, "defaultProps", {
  application: {
    club: {
      abbreviation: ''
    },
    id: '',
    submission_token: ''
  },
  jest: false,
  postage: {
    value: '',
    description: '',
    cost: 0
  },
  setTransaction: () => null,
  transaction: {
    success: false
  },
  validate: () => null
});
const mapStateToProps = ({
  addresses,
  application,
  club,
  contacts,
  cookies,
  dateOfBirth,
  dateOfTravel,
  email,
  images,
  names,
  licenceClass,
  licenceExpiry,
  licenceNumber,
  placeOfBirth,
  postage,
  stateOfIssue,
  transaction,
  terms
}) => {
  return {
    addresses,
    application,
    club,
    contacts,
    cookies,
    dateOfBirth,
    dateOfTravel,
    email,
    images,
    names,
    licenceClass,
    licenceExpiry,
    licenceNumber,
    placeOfBirth,
    postage,
    stateOfIssue,
    transaction,
    terms
  };
};
const mapDispatchToProps = dispatch => {
  return {
    setTransaction: value => {
      dispatch(transaction(value));
    },
    validate: () => {
      dispatch(validate());
    }
  };
};
const VisiblePaymentPage = connect(mapStateToProps, mapDispatchToProps)(PaymentPage);
export default VisiblePaymentPage;